import React from 'react';
export function Logo() {
  return <div className="flex items-center gap-3" data-id="element-143">
      <div className="bg-gold text-navy font-bold text-xl w-10 h-10 flex items-center justify-center rounded-sm" data-id="element-144">
        888
      </div>
      <div className="flex flex-col leading-none" data-id="element-145">
        <span className="text-white font-bold text-sm tracking-widest" data-id="element-146">
          SOURCING
        </span>
        <span className="text-white font-bold text-sm tracking-widest" data-id="element-147">
          LIMITED
        </span>
      </div>
    </div>;
}